import clsx from "clsx"
import { FC, MouseEventHandler, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeftIcon } from "@/assets"
import { useFromUrl } from "@/hooks/useFromUrl"
import { Button } from "@/ui/Button"
import { IButtonBack } from "."
import styles from "./ButtonBack.module.scss"

export const ButtonBack: FC<IButtonBack> = ({
  toHome = false,
  onBack,
  link,

  className,
  onClick,
  ...props
}) => {
  const navigate = useNavigate()
  const { from } = useFromUrl()

  const target = useMemo(() => (from ? from : link), [link, from])

  const handleBack: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (toHome) {
      navigate("/")
      return
    }

    if (link && target) {
      navigate(target)
      return
    }

    if (onClick) {
      onClick(e)
      return
    }

    if (onBack) {
      onBack()
      return
    }

    navigate(-1)
  }

  return (
    <Button
      icon={<ArrowLeftIcon />}
      id="back-button"
      className={clsx(styles.ButtonBack, className)}
      triangleTopPosLeft="40%"
      triangleBottomPosLeft="none"
      onClick={handleBack}
      {...props}
    />
  )
}
